import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import { FiArrowLeft, FiCheck, FiCopy } from 'react-icons/fi';
import styles from '@pages/api-portal/styles.module.scss';
import { MethodBadge } from '@pages/api-portal/method-badge';
import { StatusBadge } from '@pages/api-portal/status-badge';
import { ApiEndpoint } from '@pages/api-portal/types';

interface ApiDetailHeaderProps {
    endpoint: ApiEndpoint;
}

/*
 * Catalog detail hero: back link, method/title/status, path with copy, tags, and version.
 */
export function ApiDetailHeader({ endpoint }: ApiDetailHeaderProps) {
    const [copied, setCopied] = useState(false);

    const copyPath = async () => {
        try {
            await navigator.clipboard.writeText(endpoint.path);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // Clipboard API unavailable — nothing further to do.
        }
    };

    return (
        <div style={{ padding: '16px 0', borderBottom: '1px solid #666a8d', marginBottom: 16 }}>
            <Link
                to="/api-portal/catalog"
                className={styles.mutedText}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 8 }}
            >
                <FiArrowLeft /> Back to Catalog
            </Link>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MethodBadge method={endpoint.method} />
                    <h2 style={{ margin: 0, color: '#fff', fontSize: 20, fontWeight: 600 }}>{endpoint.name}</h2>
                    {endpoint.status && <StatusBadge status={endpoint.status} />}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <code className={styles.mutedText} style={{ fontSize: 12 }}>
                        {endpoint.path}
                    </code>
                    {copied ? (
                        <FiCheck onClick={copyPath} style={{ cursor: 'pointer', color: '#52c41a' }} />
                    ) : (
                        <FiCopy onClick={copyPath} style={{ cursor: 'pointer' }} />
                    )}
                </div>
            </div>
            <p className={styles.mutedText} style={{ marginBottom: 8 }}>{endpoint.description}</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div>
                    {endpoint.tags.map((tag) => (
                        <Tag key={tag}>{tag}</Tag>
                    ))}
                </div>
                <span className={styles.mutedText} style={{ fontSize: 13 }}>
                    Version: <strong style={{ color: '#fff' }}>{endpoint.version}</strong>
                </span>
            </div>
        </div>
    );
}
